<template>
    <div class="starbrand">
        <div class="headerbox">
            <div class="searchbox">
                <el-select v-model="params.industry" filterable placeholder="请选择" style="height:40px;margin-bottom:8px" @change="searchData">
                    <el-option v-for="item in industryList" :key="item.bigIndustryCode" :label="item.bigIndustryName"
                        :value="item.bigIndustryCode">
                    </el-option>
                </el-select>
            </div>
            <!-- <div class="filiter"><img src="@/assets/img/mobile/shaixuan.png" alt="" @click="filiterShow = true"></div> -->

        </div>

        <div class="infinite-list-wrapper">
            <div class="scrollbox">
                <el-card shadow="never" class="box-card" v-for="(item, index) in affList" :key="item.allianceCode">
                    <div class="affitem">
                        <el-row>
                            <el-col :span="24" style="margin-bottom: 8px;">
                                <div class="headsrc">
                                    <img :src="item.domain" alt="" />
                                </div>
                            </el-col>
                            <el-col :span="24" style="margin-bottom: 8px;">
                                <div class="name">
                                    <div class="item_tit_text">{{ item.brandName }}<span class="sz12">{{
                                        item.country
                                    }}</span></div>
                                </div>
                            </el-col>
                            <el-col :span="8" style="margin-bottom: 8px;">
                                <div class="yjbl">
                                    佣金比例&nbsp;<span class="sz12 co6e font_r">{{
                                        item.commissionRate ?
                                        item.commissionRate
                                        : ''
                                    }}</span>
                                </div>
                            </el-col>
                            <el-col :span="8" style="margin-bottom: 8px;">
                                <div class="headsrc">
                                    EPC&nbsp;<span class="sz12 co6e font_r">{{
                                        item.epc ?
                                        item.epc
                                        : ''
                                    }}</span>
                                </div>
                            </el-col>
                            <el-col :span="8" style="margin-bottom: 8px;">
                                <div class="headsrc">
                                    Cookies&nbsp;<span class="sz12 co6e font_r">{{
                                        item.cookiesDay ?
                                        item.cookiesDay
                                        : ''
                                    }}</span>
                                </div>
                            </el-col>
                            <el-col :span="24" style="margin-bottom: 8px;">
                                <div id="charts">
                                    <div :id="'myChart' + (index + 1)" :style="{ width: '100%', height: '100%' }"></div>
                                </div>
                            </el-col>
                            <el-col :span="8"
                                v-for="(item2, index2) in item.allianceGuestPlatformLogosList"
                                :key="index2">
                                <div class="plat">
                                    <img :src="item2" alt="">
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
                <el-divider v-if="loading">加载中...</el-divider>
                <div class="nodata" v-if="totalpages === 0">
                    <img src="@/assets/img/nodata.png" alt="">
                    <div>暂无数据</div>
                </div>
            </div>

        </div>


        <el-drawer :visible.sync="filiterShow" :with-header="false" size="65%">
            <div class="myfiliter">
                <div class="title">
                    行业
                </div>
                <el-select v-model="params.industry" filterable placeholder="请选择" style="height:40px;margin-bottom:8px">
                    <el-option v-for="item in industryList" :key="item.bigIndustryCode" :label="item.bigIndustryName"
                        :value="item.bigIndustryCode">
                    </el-option>
                </el-select>

                <div class="footer">
                    <el-row :gutter="8">
                        <el-col :span="12">
                            <div class="reset"> <el-button type="primary" style="width:100%"
                                    @click="resetFiliter">重置</el-button>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="submit"> <el-button type="primary" style="width:100%"
                                    @click="searchData">确定</el-button></div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </el-drawer>
    </div>
</template>
<script>
import { INDUSTRYS, BRANDSBYINDUSTRY, BRANDS, BRAND, CHECKBRAND, COUNTRYBRAND, INDUSTRYY, QUERYSELECTLIST, QUERYUSERGROUP, QUERY, JOINGROUP, CHECKALLINDUSTRYBRAND, QUERYHASGROUP, QUERYCHAT } from "@/api/cutting";
import { REMOVEGROUPONEDETAIL, } from '@/api/foll'
export default {
    data() {
        return {
            searchValue: '',
            params: {
                currentPage: 1,
                size: 10,
                industry: '',
            },
            totalpages: null,
            loading: false,
            affList: [],
            filiterShow: false,
            industryList: [],

        }
    },
    computed: {
        disabled() {
            return this.loading || (this.totalpages == this.params.currentPage)
        },
        titleIndustry() {
            let str
            this.industryList.forEach(item => {
                if (item.bigIndustryCode == this.params.industry) {
                    str = item.bigIndustryName
                }
            })
            return str
        }
    },
    created() {
        this.permitsList()
    },
    mounted() {

    },
    methods: {
        //获取下拉数据
        permitsList() {
            INDUSTRYS().then(res => {
                console.log(res.data.body)
                this.industryList = res.data.body
                this.params.industry = res.data.body[0].bigIndustryCode
                this.getData()
            })
        },
        //重置条件
        resetFiliter() {
            this.params = {
                currentPage: 1,
                size: 10,
                industry: this.industryList[0].bigIndustryCode,
            }
            this.searchData()
            this.filiterShow = false
        },
        getData() {
            this.loading = true
            BRANDSBYINDUSTRY({ bigIndustryCode: this.params.industry }).then(res => {
                console.log(res.data.body)
                this.affList = []
                this.totalpages = res.data.body.pages
                let arr = res.data.body
                this.affList = arr
                this.$nextTick(() => {
                    this.drawPie1()
                })

                this.loading = false
            }).catch(err => {
                this.loading = false
            })
        },
        //搜索联盟客
        searchData() {
            this.params.name = this.searchValue
            this.params.currentPage = 1
            this.getData()
            this.filiterShow = false
        },
        // 行业环形图数据处理
        drawPie1() {
            let myChart1 = this.$echarts.init(document.getElementById("myChart1"));
            let myChart2 = this.$echarts.init(document.getElementById("myChart2"));
            let myChart3 = this.$echarts.init(document.getElementById("myChart3"));
            let myChart4 = this.$echarts.init(document.getElementById("myChart4"));
            let myChart5 = this.$echarts.init(document.getElementById("myChart5"));
            let myChart6 = this.$echarts.init(document.getElementById("myChart6"));
            let arr1 = this.affList[0].types
            let arr2 = this.affList[1].types
            let arr3 = this.affList[2].types
            let arr4 = this.affList[3].types
            let arr5 = this.affList[4].types
            let arr6 = this.affList[5].types

            myChart1.setOption({
                tooltip: {
                    trigger: "item",
                    formatter: "{b} ({d}%)",
                    textStyle: {
                        fontSize: 12
                    }
                },
                legend: {
                    orient: 'horizontal',
                    right: 10,
                    // top: '-10%',
                    icon: "rect",
                    itemGap: 10,
                    x: '30%',
                    y: 'top',
                    itemHeight: 10, // 图例icon高度
                    itemWidth: 10, // 图例icon宽度
                    padding: [10, 0],
                    textStyle: {
                        fontSize: 10
                    }
                },
                series: [
                    {
                        type: "pie",
                        radius: ["45%", "75%"],
                        data: arr1,
                        color: ['#DDB2F9', '#F89589', '#2CD4D3', '#9577e5', '#FEC776', '#FC6780', '#7892EC', '#B28C68', '#dfb7b4', '#3b2e36', '#647e43', '#d0d0d0'],
                        itemStyle: {
                            normal: {
                                label: {
                                    show: false
                                },
                                labelLine: {
                                    show: false
                                }
                            },
                        },
                        center: ['50%', '50%'],
                    },

                ],
            });
            myChart2.setOption({
                tooltip: {
                    trigger: "item",
                    formatter: "{b} ({d}%)",
                    textStyle: {
                        fontSize: 12
                    }
                },
                legend: {
                    orient: 'horizontal',
                    right: 10,
                    icon: "rect",
                    itemGap: 10,
                    x: '30%',
                    y: 'top',
                    itemHeight: 10, // 图例icon高度
                    itemWidth: 10, // 图例icon宽度
                    padding: [10, 0],
                    textStyle: {
                        fontSize: 10
                    }
                },
                series: [
                    {
                        type: "pie",
                        radius: ["45%", "75%"],
                        data: arr2,
                        color: ['#DDB2F9', '#F89589', '#2CD4D3', '#9577e5', '#FEC776', '#FC6780', '#7892EC', '#B28C68', '#dfb7b4', '#3b2e36', '#647e43', '#d0d0d0'],
                        itemStyle: {
                            normal: {
                                label: {
                                    show: false
                                },
                                labelLine: {
                                    show: false
                                }
                            },
                        },
                        center: ['50%', '50%'],
                    },

                ],
            });
            myChart3.setOption({
                tooltip: {
                    trigger: "item",
                    formatter: "{b} ({d}%)",
                    textStyle: {
                        fontSize: 12
                    }
                },
                legend: {
                    orient: 'horizontal',
                    right: 10,
                    icon: "rect",
                    itemGap: 10,
                    x: '30%',
                    y: 'top',
                    itemHeight: 10, // 图例icon高度
                    itemWidth: 10, // 图例icon宽度
                    padding: [10, 0],
                    textStyle: {
                        fontSize: 10
                    }
                },
                series: [
                    {
                        type: "pie",
                        radius: ["45%", "75%"],
                        data: arr3,
                        color: ['#DDB2F9', '#F89589', '#2CD4D3', '#9577e5', '#FEC776', '#FC6780', '#7892EC', '#B28C68', '#dfb7b4', '#3b2e36', '#647e43', '#d0d0d0'],
                        itemStyle: {
                            normal: {
                                label: {
                                    show: false
                                },
                                labelLine: {
                                    show: false
                                }
                            },
                        },
                        center: ['50%', '50%'],
                    },

                ],
            });
            myChart4.setOption({
                tooltip: {
                    trigger: "item",
                    formatter: "{b} ({d}%)",
                    textStyle: {
                        fontSize: 14
                    }
                },
                legend: {
                    orient: 'horizontal',
                    right: 10,
                    icon: "rect",
                    itemGap: 10,
                    x: '30%',
                    y: 'top',
                    itemHeight: 10, // 图例icon高度
                    itemWidth: 10, // 图例icon宽度
                    padding: [10, 0],
                    textStyle: {
                        fontSize: 10
                    }
                },
                series: [
                    {
                        type: "pie",
                        radius: ["45%", "75%"],
                        data: arr4,
                        color: ['#DDB2F9', '#F89589', '#2CD4D3', '#9577e5', '#FEC776', '#FC6780', '#7892EC', '#B28C68', '#dfb7b4', '#3b2e36', '#647e43', '#d0d0d0'],
                        itemStyle: {
                            normal: {
                                label: {
                                    show: false
                                },
                                labelLine: {
                                    show: false
                                }
                            },
                        },
                        center: ['50%', '50%'],
                    },

                ],
            });
            myChart5.setOption({
                tooltip: {
                    trigger: "item",
                    formatter: "{b} ({d}%)",
                    textStyle: {
                        fontSize: 12
                    }
                },
                legend: {
                    orient: 'horizontal',
                    right: 10,
                    // top: '10%',
                    icon: "rect",
                    itemGap: 10,
                    x: '30%',
                    y: 'top',
                    itemHeight: 10, // 图例icon高度
                    itemWidth: 10, // 图例icon宽度
                    padding: [10, 0],
                    textStyle: {
                        fontSize: 10
                    }
                },
                series: [
                    {
                        type: "pie",
                        radius: ["45%", "75%"],
                        data: arr5,
                        color: ['#DDB2F9', '#F89589', '#2CD4D3', '#9577e5', '#FEC776', '#FC6780', '#7892EC', '#B28C68', '#dfb7b4', '#3b2e36', '#647e43', '#d0d0d0'],
                        itemStyle: {
                            normal: {
                                label: {
                                    show: false
                                },
                                labelLine: {
                                    show: false
                                }
                            },
                        },
                        center: ['50%', '50%'],
                    },

                ],
            });
            myChart6.setOption({
                tooltip: {
                    trigger: "item",
                    formatter: "{b} ({d}%)",
                    textStyle: {
                        fontSize: 12
                    }
                },
                legend: {
                    orient: 'horizontal',
                    right: 10,
                    icon: "rect",
                    itemGap: 10,
                    x: '30%',
                    y: 'top',
                    itemHeight: 10, // 图例icon高度
                    itemWidth: 10, // 图例icon宽度
                    padding: [10, 0],
                    textStyle: {
                        fontSize: 10
                    }
                },
                series: [
                    {
                        type: "pie",
                        radius: ["45%", "75%"],
                        data: arr6,
                        color: ['#DDB2F9', '#F89589', '#2CD4D3', '#9577e5', '#FEC776', '#FC6780', '#7892EC', '#B28C68', '#dfb7b4', '#3b2e36', '#647e43', '#d0d0d0'],
                        itemStyle: {
                            normal: {
                                label: {
                                    show: false
                                },
                                labelLine: {
                                    show: false
                                }
                            },
                        },
                        center: ['50%', '50%'],
                    },

                ],
            });
            myChart1.resize();
            myChart2.resize();
            myChart3.resize();
            myChart4.resize();
            myChart5.resize();
            myChart6.resize();
        },
    }
}
</script>
<style lang="less" scoped>
.starbrand {
    height: 100%;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    padding: 53px 8px 8px 8px;
    background-color: #fff;

    /deep/.el-card__body {
        padding: 8px !important;
    }

    .headerbox {
        display: flex;
        position: fixed;
        top: 58px;
        width: calc(100% - 16px);
        background-color: #fff;
        z-index: 10;

        .searchbox {
            flex: auto;
        }

        .filiter {
            padding: 5px;

            img {
                width: 35px;
                height: 35px;
            }
        }
    }

    .infinite-list-wrapper {
        margin-top: 8px;
        height: 100%;

        .scrollbox {
            height: 100%;
            overflow: auto;
        }

        .box-card {
            margin-bottom: 8px;

            .affitem {
                img {
                    width: 100%;
                }

                font-size: 12px;
                text-align: center;

                .name {
                    font-size: 14px;
                    text-align: left;
                    font-weight: 600;
                }

                .yjbl {
                    text-align: left;
                }

                .plat {
                    text-align: left;
                    padding: 5px 8px;
                    overflow: hidden;

                    img {
                        width: auto;
                        height: 20px;
                    }
                }

                #charts {
                    width: 100%;
                    height: 120px;
                }
            }
        }

        .nodata {
            margin-top: 45%;
            text-align: center;

            div {
                margin-top: 8px;
                color: #bfbfbf;
            }
        }
    }
}

.myfiliter {
    height: 100%;
    width: 100%;
    padding: 8px;
    position: relative;

    .title {
        font-weight: 600;
        margin-bottom: 8px;
    }

    .footer {
        padding-top: 8px;
        width: calc(100% - 16px);
        position: absolute;
        bottom: 8px;

        .reset {
            width: 100%;
        }

        .submit {
            width: 100%;
        }
    }
}
</style>